// ABOUTME: Validation utilities for family management forms
// ABOUTME: Provides consistent validation logic for family info, members, and children

export const validateFamilyName = (name: string): string => {
  if (!name || name.trim() === '') {
    return 'Family name is required';
  }
  return '';
};

export const validateEmail = (email: string): string => {
  if (!email || email.trim() === '') {
    return 'Email is required';
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  return '';
};

export const validateFirstName = (name: string): string => {
  if (!name || name.trim() === '') {
    return 'First name is required';
  }
  return '';
};

export const validateLastName = (name: string): string => {
  if (!name || name.trim() === '') {
    return 'Last name is required';
  }
  return '';
};

export const validateChildName = (name: string): string => {
  if (!name || name.trim() === '') {
    return 'Name is required';
  }
  return '';
};

export const validateBirthYear = (year: number): string => {
  const currentYear = new Date().getFullYear();
  if (!year || year < 1900) {
    return 'Please enter a valid birth year';
  }
  if (year > currentYear) {
    return 'Birth year cannot be in the future';
  }
  return '';
};

export const validateBirthMonth = (month: string): string => {
  if (!month || month.trim() === '') {
    return 'Birth month is required';
  }
  return '';
};

export const validateGender = (gender: string): string => {
  if (!gender || gender.trim() === '') {
    return 'Gender is required';
  }
  return '';
};

export const validatePassword = (password: string): string => {
  if (!password || password.trim() === '') {
    return 'Password is required';
  }
  if (password.length < 6) {
    return 'Password must be at least 6 characters long';
  }
  return '';
};

export const validateConfirmPassword = (password: string, confirmPassword: string): string => {
  if (!confirmPassword || confirmPassword.trim() === '') {
    return 'Please confirm your password';
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match';
  }
  return '';
};
